import React, { useEffect, useState } from "react";
import "./Contract.css";
import axios from "axios";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSpring, animated } from "react-spring";
import usa from "./images/icons8-usa-23.png";

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style }}
      onClick={onClick}
      aria-label="Next slide"
    >
      <i className="fa-solid fa-chevron-right"></i>
    </div>
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style }}
      onClick={onClick}
      aria-label="Previous slide"
    >
      <i className="fa-solid fa-chevron-left"></i>
    </div>
  );
}

function Plan(props) {
  const [plans, setPlans] = useState([]);
  const [activeDot, setActiveDot] = useState(0);

  useEffect(() => {
    axios
      .get("https://serverforstripe.vercel.app/api/plans")
      .then((res) => {
        setPlans(res.data);
      })
      .catch((err) => {
        console.error("Error fetching plans:", err);
      });
  }, []);

  const propsSpring = useSpring({
    opacity: 1,
    from: { opacity: 0 },
  });

  const handleBeforeChange = (oldIndex, newIndex) => {
    setActiveDot(newIndex);
  };

  const settings = {
    dots: true,
    infinite: plans.length > 3,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: handleBeforeChange,
    customPaging: (i) => (
      <div
        className={`custom-dot ${i === activeDot ? "active" : ""}`}
        key={i}
        style={{
          width: "14px",
          height: "14px",
          background: i === activeDot ? "#FFD87F" : "#D8D4D5",
          borderRadius: "50%",
          cursor: "pointer",
          transition: "all 0.3s ease-in-out",
        }}
      ></div>
    ),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: plans.length > 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: plans.length > 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: plans.length > 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="container">
        <p className="cdl">Be part of United CDL</p>
        <p className="new-stage-content">
          Complete your registration and start a{" "}
          <span style={{ color: "#F2B320" }}> new stage in your life</span>
        </p>
        <div className="tabs">
          <p className=" active2">Registration data</p>
          <p className="smallscreenyellow"></p>
          <p className="dotsmal">..</p>
          <p className="dots">....</p>
          <p className="tab-list active1">
            <b>Course</b>
          </p>
          <p className="dots">....</p>
          <p className="dotsgreymall">..</p>

          <p className="tab-list notActive">Payment</p>
          <p className=" smallscreenitem"></p>
        </div>
      </div>

      {plans.length > 0 ? (
        <div className="caroselcomponent">
          <animated.div style={propsSpring} className="container px-0">
            <Slider {...settings}>
              {plans.map((plan) => (
                <div key={plan._id} className="plan-slide-item">
                  <div className="card-content">
                    <div className="plancard d-flex mt-2">
                      <img
                        src={plan.image}
                        height="58px"
                        alt={plan.courseName || "plan"}
                      />
                      <span className="flex-end">
                        <sup className="dollar-sup">$</sup>
                        <span className="main-price">{plan.price / 100}</span>
                      </span>
                    </div>

                    <span className="classer">{plan.courseName}</span>
                    <div className="d-flex mt-4">
                      <div className="categoria">
                        <span>Category</span>
                        <br />
                        <strong className="strongcontent">
                          {plan.category}
                        </strong>
                      </div>
                      <div className="ultima">
                        <span>Last Updated</span>
                        <br />
                        <strong className="strongcontent">07/07/2023</strong>
                      </div>
                    </div>

                    <div className="mt-3 Acesso d-flex align-items-center">
                      <img
                        src={usa}
                        alt="English"
                        className="me-2"
                        style={{ width: "23px", height: "23px" }}
                      />
                      <span>English</span>
                    </div>

                    <div className="mt-3 Acesso">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                      >
                        <path
                          d="M12 21.8086C16.9706 21.8086 21 17.7792 21 12.8086C21 7.83803 16.9706 3.80859 12 3.80859C7.02944 3.80859 3 7.83803 3 12.8086C3 17.7792 7.02944 21.8086 12 21.8086Z"
                          stroke="#FBB723"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 7.55859V12.8086H17.25"
                          stroke="#FBB723"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>{" "}
                      <span>
                        Access:
                        <strong className="strong-text">Unlimited</strong>{" "}
                      </span>
                    </div>

                    <div className="mt-3 Acesso">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                      >
                        <path
                          d="M12 17.3086C16.1421 17.3086 19.5 13.9507 19.5 9.80859C19.5 5.66646 16.1421 2.30859 12 2.30859C7.85786 2.30859 4.5 5.66646 4.5 9.80859C4.5 13.9507 7.85786 17.3086 12 17.3086Z"
                          stroke="#FBB723"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 14.3086C14.4853 14.3086 16.5 12.2939 16.5 9.80859C16.5 7.32331 14.4853 5.30859 12 5.30859C9.51472 5.30859 7.5 7.32331 7.5 9.80859C7.5 12.2939 9.51472 14.3086 12 14.3086Z"
                          stroke="#FBB723"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M16.5 15.8086V23.3086L12 21.0586L7.5 23.3086V15.8086"
                          stroke="#FBB723"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>{" "}
                      <span>
                        Certificate:
                        <strong className="strong-text">Yes</strong>{" "}
                      </span>
                    </div>

                    <Link to={`/payment/${plan._id}`}>
                      <button
                        className="mt-3 buy-button"
                        onClick={() => {
                          props.addtocart(plan);
                        }}
                      >
                        Buy Now
                      </button>
                    </Link>
                  </div>
                </div>
              ))}
            </Slider>
          </animated.div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "300px",
          }}
        >
          <div className="spinner-border text-warning" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}
    </>
  );
}

export default Plan;
